<template>

    <b-row>

        <transition mode="out-in" name="slide-fade">

            <b-col v-if=" isLoading " key="first-frame">

                <loading-card></loading-card>
            </b-col>
            <b-col v-else-if=" errorsFound " key="second-frame">

                <b-card class="bg-light-danger">

                    <p class="small mb-0 font-bold text-capitalize" style="text-decoration: underline">Errors found preventing fuzzy match:</p>
                    <p class="small mb-0"><span class="font-bold">Provider First Name</span> must exist</p>
                    <p class="small mb-0"><span class="font-bold">Provider Last Name</span> must exist</p>
                    <p class="small mb-0"><span class="font-bold">Provider Address Line 1</span> must exist</p>
                    <p class="small mb-0"><span class="font-bold">Provider Zip</span>, without +4, must be 5 digits</p>
                    <p class="small mb-0"><span class="font-bold">Provider Phone</span> must be 10 digits</p>
                </b-card>
            </b-col>
            <b-col v-else key="third-frame">

                <upd-provider-card v-for=" provider in matchResults " :key=" provider.UpdId " :provider=" provider " :selectProvider=" selectProvider " :selectedProvider=" selectedProvider " :providerData=" providerdata "></upd-provider-card>
                <b-card v-if=" matchResults && matchResults.length == 0 ">

                    <p class="mb-0">No Results Found in UPD</p>
                </b-card>
            </b-col>
        </transition>
    </b-row>
</template>

<script>

    export default {

        props: {

            providerdata     : Object,
            value            : {

                type         : Array,
                default      : [],
                required     : false
            },
            selectedProvider : {

                type         : Object,
                default      : null,
                required     : false
            },
            selectProvider   : Function
        },
        data(){

            return {

                isLoading   : false,
                errorsFound : false
            }
        },
        computed: {

            matchResults: {

                get: function () {

                    return this.value;
                },
                set: function ( newValue ){

                    this.$emit( 'input', newValue );
                }
            }
        },
        methods: {

            fuzzyMatch(){

                this.errorsFound = false;
                let form = new Form( this.providerdata );
                form.alertOnSuccess = false;
                this.isLoading = true;
                form.post( '/business/upd_api/fuzzyMatch' )
                    .then( res => this.matchResults = res.data.data )
                    .catch( err => {

                        this.errorsFound = true;
                    })
                    .finally( () => this.isLoading = false );
            }
        },
        mounted(){

            this.fuzzyMatch();
        }
    }
</script>

<style>

</style>